import { render, staticRenderFns } from "./SortLabel.vue?vue&type=template&id=82c4190c&scoped=true&"
import script from "./SortLabel.vue?vue&type=script&lang=js&"
export * from "./SortLabel.vue?vue&type=script&lang=js&"
import style0 from "./SortLabel.vue?vue&type=style&index=0&id=82c4190c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c4190c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82c4190c')) {
      api.createRecord('82c4190c', component.options)
    } else {
      api.reload('82c4190c', component.options)
    }
    module.hot.accept("./SortLabel.vue?vue&type=template&id=82c4190c&scoped=true&", function () {
      api.rerender('82c4190c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/SortLabel.vue"
export default component.exports